// We only need to import the modules necessary for initial render
import CoreLayout from '../layouts/PageLayout/PageLayout'
import LoginRoute from './Login'
import SignupRoute from './Signup'
import SettingRoute from './Setting'
import ResetPassRoute from './ResetPassword'
import Main from './Main'
import Admin from './MainAdmin'
import {browserHistory} from 'react-router'
import {userInfo} from './Main/modules/main'
import { initialize, addTranslation, addTranslationForLanguage  } from 'react-localize-redux';
let languagesp =  require('languagesp').default;
let config =  require('config');

/*  Note: Instead of using JSX, we recommend using react-router
    PlainRoute objects to build route definitions.   */
const loginReq = () => {
  if(!localStorage.access_token) {
    browserHistory.push('/login');
  } 
}
const homeRedirect = (store) => {
  if(localStorage.access_token) {
    if(localStorage.admin === 'true'){
        browserHistory.push('/admin');
    } else {
        browserHistory.push('/');
    }
  }
}

export const createRoutes = (store) => ({
  path        : '/',
  component   : CoreLayout,
  onEnter: function() {
    const local = ['en', 'sp'];
    store.dispatch(initialize(local, { defaultLanguage: process.env.APP_LANG || config.language.key }));
    store.dispatch(addTranslationForLanguage(languagesp.en, 'en'));
    store.dispatch(addTranslationForLanguage(languagesp.sp, 'sp'));
  },
  childRoutes : [
    {
      onEnter: loginReq,
      childRoutes: [
        Main(store),
        Admin(store)
      ]
    },
    {
      onEnter: homeRedirect,
      childRoutes: [
        LoginRoute(store),
        // SignupRoute(store),
        ResetPassRoute(store)
      ]
    }
  ]
})

export default createRoutes
/*  Note: childRoutes can be chunked or otherwise loaded programmatically
    using getChildRoutes with the following signature:

    getChildRoutes (location, cb) {
      require.ensure([], (require) => {
        cb(null, [
          // Remove imports!
          require('./Counter').default(store)
        ])
      })
    }

    However, this is not necessary for code-splitting! It simply provides
    an API for async route definitions. Your code splitting should occur
    inside the route `getComponent` function, since it is only invoked
    when the route exists and matches.
*/




// WEBPACK FOOTER //
// ./src/routes/index.js